export default __webpack_public_path__ + "static/media/START.0d2dcaac.png";